import { ELocale } from "@/context/language/language.types";

export const getValidLocale = (
  options: string | undefined | null | Array<string | undefined | null>,
): ELocale => {
  if (Array.isArray(options)) {
    return (
      (options.find((option) => !!option && option in ELocale) as
        | ELocale
        | undefined) || ELocale.en
    );
  } else {
    return (
      (options && options in ELocale ? (options as ELocale) : undefined) ||
      ELocale.en
    );
  }
};

export const pickPaddleLocale = (locale: string) => {
  const validLocale = getValidLocale(locale);

  return {
    [ELocale.en]: "en",
    [ELocale.ru]: "ru",
    [ELocale.es]: "es",
    [ELocale.pt]: "pt",
    [ELocale.uk]: "ru",
    [ELocale.kk]: "ru",
    [ELocale.ro]: "en",
  }[validLocale];
};
